export const USER_IDS = { HIA: 35 };
export const ROLE_IDS = { JUDGE_REVIEWER: 12 };
export const HIA_APPROVED_STATUSES = [18, 22, 23, 24, 25, 26];
export const JUDGMENT_REVIEWED_THRESHOLD = 16;

export const MESSAGES = {
  NO_DATA: "ไม่มีข้อมูล",
  HIA_NOT_APPROVED: "เฮียยังไม่อนุมัติ",
  JUDGMENT_NOT_REVIEWED: "ยังไม่ตรวจคำพิพากษา",
  LOAD_ERROR: "เกิดข้อผิดพลาดในการโหลดข้อมูลคดี",
};
